import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { routes } from '~/constants';
import { useAppSelector } from '~/hooks/store';
import { selectAuth } from '~/store/admin/selectors';

interface Props {
  redirectPath?: string;
  children: React.ReactNode;
}

const PrivateRoute = (props: Props) => {
  const { redirectPath = routes.LOGIN, children } = props;
  const auth = useAppSelector(selectAuth);
  const location = useLocation();

  if (!auth.isLoggedIn) {
    return <Navigate to={redirectPath} state={{ from: `${location.pathname}${location.search}` }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
